import * as React from 'react'
import { useRouter } from 'next/router'
import * as Auth from 'contexts/authentication'
import Client from './'

const { client } = Client

export function useDeleteSubmission() {
    const { locale } = useRouter()
    const { getAccessTokenSilently } = Auth.useAuth()

    return React.useCallback(
        id => {
            const path = [locale, 'submissions', id]

            return client.delete(path, getAccessTokenSilently)
        },
        [locale, getAccessTokenSilently]
    )
}

export function useUndoDeleteSubmission() {
    const { locale } = useRouter()
    const { getAccessTokenSilently } = Auth.useAuth()

    return React.useCallback(
        id => {
            const path = [locale, 'submissions', id, 'undelete']

            return client.post(path, null, getAccessTokenSilently)
        },
        [locale, getAccessTokenSilently]
    )
}

export function useSaveSubmission() {
    const { locale } = useRouter()
    const { getAccessTokenSilently } = Auth.useAuth()

    return React.useCallback(
        data => {
            const { submissionID } = data
            const path = [locale, 'submissions', submissionID]
            const save = submissionID ? client.put : client.post

            return save.call(client, path, data, getAccessTokenSilently)
        },
        [locale, getAccessTokenSilently]
    )
}

export function usePostImages() {
    return React.useCallback(async files => {
        const promises = []

        for (const file of files) {
            const formData = new FormData()
            formData.append('file', file)
            formData.append('upload_preset', process.env.NEXT_PUBLIC_CLOUDINARY_UPLOAD_PRESET)

            promises.push(
                fetch(process.env.NEXT_PUBLIC_CLOUDINARY_URL, {
                    method: 'POST',
                    body: formData,
                }).then(response => response.json())
            )
        }

        const results = await Promise.allSettled(promises)

        const error = results.some(result => result.status === 'rejected' || result.value.error)

        if (error) {
            // TODO: give user some indication that an error has occurred
            console.log('error', error)
            throw new Error('Failed to upload image(s)')
        }

        return results.filter(result => result.status !== 'rejected' && !result.value.error).map(result => result.value)
    }, [])
}

export function uploadImage(url, file) {
    return fetch(url, {
        method: 'PUT',
        body: file,
        headers: {
            'content-type': file.type,
        },
    })
}
